module.exports = __webpack_public_path__ + "static/media/add-bnr.116c8f38.jpg";